import { useState, useEffect } from 'react';

/**
 * Returns true when the CSS media query matches, false otherwise.
 * Subscribes to changes so the value updates when the viewport resizes.
 *
 * Usage:
 *   const isWide = useMediaQuery('(min-width: 640px)');
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(query);
    // eslint-disable-next-line react-hooks/set-state-in-effect -- one-shot sync from external prop on mount
    setMatches(mq.matches);

    function handleChange(e: MediaQueryListEvent) {
      setMatches(e.matches);
    }

    mq.addEventListener('change', handleChange);
    return () => {
      mq.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}
